<template>
<div>
  <div style="padding: 10px;background-color: #ffffff;">
    <div>
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
        <el-descriptions-item label="催费类型">
          <el-select size="mini" v-model="where.type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in ['自催','诉讼','第三方','第三方管理','第三方诉讼']" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="账龄类型">
          <el-select size="mini" v-model="where.zl_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in ['当期','纯上1年','1年以上2年以内','2年以上']" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="欠费月份">
          <el-date-picker
            @change="pageChange(1)"
            v-model="where.qf_time"
            size="mini"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM" placeholder="欠费月份">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="计划催费月份">
          <el-date-picker
            @change="pageChange(1)"
            v-model="where.jh_time"
            size="mini"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM" placeholder="计划催费月份">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="输入房产">
          <el-input clearable placeholder="输入房产" v-model="where.house_name" size="mini" @input="pageChange(1)"></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="header-tip">
      <div>
        审核房产数：{{new_count_obj['总数']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        自催：{{new_count_obj['自催']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        诉讼：{{new_count_obj['诉讼']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        第三方管理：{{new_count_obj['第三方管理']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        第三方诉讼：{{new_count_obj['第三方诉讼']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        未设置：{{new_count_obj['未设置']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        当期：{{new_count_obj['当期']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        纯上1年：{{new_count_obj['纯上1年']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        1年以上2年以内：{{new_count_obj['1年以上2年以内']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        2年以上：{{new_count_obj['2年以上']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        纯上一年：{{new_count_obj['纯上一年']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
      <div>
        系统房产数：{{old_count_obj['总数']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        自催：{{old_count_obj['自催']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        诉讼：{{old_count_obj['诉讼']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        第三方管理：{{old_count_obj['第三方管理']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        第三方诉讼：{{old_count_obj['第三方诉讼']}}&nbsp;&nbsp;
        未设置：{{old_count_obj['未设置']}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
    </div>
    <el-table
      v-loading="loading"
      v-if="pageData" :data="pageData.list"
      border
      style="width: 100%" height="75vh">
      <el-table-column
        prop="房产信息"
        label="房产信息" width="320" fixed></el-table-column>
      <el-table-column
        prop="区域"
        label="区域"
        width="90">
      </el-table-column>
      <el-table-column
        prop="业主"
        label="业主姓名"
        width="100">
      </el-table-column>
      <el-table-column
        prop="业主电话"
        label="业主电话"
        width="150">
      </el-table-column>
      <el-table-column
        label="银行划扣"
        width="90">
        <template slot-scope="scope">
          <span style="color: #328628" v-if="scope.row.bankType">是</span>
          <span v-if="!scope.row.bankType"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="欠费起始月份"
        label="欠费起始月份"
        width="120">
      </el-table-column>
      <el-table-column
        prop="欠费月数"
        label="欠费月数"
        width="100">
      </el-table-column>
      <el-table-column
        prop="欠费金额"
        label="欠费金额"
        width="100">
        <template slot-scope="scope">
          <el-link type="primary" size="mini" @click="getHouseBill(scope.row)">{{ scope.row['欠费金额'] }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="诉讼金额"
        label="诉讼金额"
        width="100">
      </el-table-column>
      <el-table-column
        prop="计划催缴月份"
        label="计划催缴月份"
        width="100">
      </el-table-column>
      <el-table-column
        prop="催缴类型"
        label="催缴类型"
        width="90">
      </el-table-column>
      <el-table-column
        prop="账龄类型"
        label="账龄类型"
        width="90">
      </el-table-column>
      <el-table-column
        prop="第三方合作单位"
        label="第三方合作单位"
        width="150">
      </el-table-column>
      <el-table-column
        prop="缴费类型"
        label="缴费类型"
        width="90">
      </el-table-column>
      <el-table-column
        prop="上次缴费时间"
        label="上次缴费时间"
        width="170"></el-table-column>
      <el-table-column
        prop="第一次催费时间"
        label="第一次催费时间"
        width="150">
      </el-table-column>
      <el-table-column
        prop="第二次催费时间"
        label="第二次催费时间"
        width="150">
      </el-table-column>
      <el-table-column
        prop="第三次催费时间"
        label="第三次催费时间"
        width="150">
      </el-table-column>
      <el-table-column
        prop="催费次数"
        label="催费次数"
        width="90">
      </el-table-column>
      <el-table-column
        prop="欠费类型"
        label="欠费类型"
        width="150">
      </el-table-column>
      <el-table-column
        prop="欠费原因"
        label="欠费原因"
        width="150">
      </el-table-column>
      <el-table-column
        prop="业主诉求"
        label="业主诉求"
        width="150">
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>
</div>
</template>

<script>
import {CommonHelp} from "./common/CommonHelp";
import ButlerHttp from "./common/ButlerHttp";

export default {
  name: "LegalPlanFlowList",
  data(){
    return{
      batch_number:"",
      loading:false,
      where:{
        type:"",
        zl_type:"",
        qf_time:"",
        jh_time:"",
        house_name:""
      },
      pageData:{
        list: [],
        total: 0,
        pageSize: 30,
        page: 1,
      },
      new_count_obj:{},
      old_count_obj:{}
    }
  },
  mounted() {
    this.batch_number=this.$route.query.batch_number||""
    if(this.batch_number){
      this.getCount();
      this.pageChange(1)
    }
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      ButlerHttp.get("Legal/getLegalHouseToBatchNumber", {
        batch_number: that.batch_number,
        ...that.where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    getCount(){
      const that = this;
      ButlerHttp.get("Legal/getLegalHouseToBatchNumberCount", {
        batch_number: that.batch_number
      }, res => {
        if (res.code) {
          that.new_count_obj = res.data.house_urge_temp;
          that.old_count_obj = res.data.house_urge;
        }
      });
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
  }
}
</script>

<style lang="scss" scoped>
.pagination-wrap{
  text-align: center;
}
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/LegalPlanFlowList.vue